
export default function AboutSection() {
  return (
    <section id="about" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">店舗情報</h2>
          <p className="text-xl text-gray-600">
            お仕事終わりにも通えるよう夜間も対応。皆様のお越しをお待ちしております
          </p>
        </div>
        
        <div className="max-w-4xl mx-auto">
          <div className="space-y-8">
            <div className="bg-white rounded-xl p-8 shadow-lg">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">ボディケア専門店H&K</h3>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="flex items-start">
                  <div className="w-6 h-6 flex items-center justify-center mr-4 mt-1">
                    <i className="ri-map-pin-line text-teal-600"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">住所</h4>
                    <p className="text-gray-600">〒971-8182　福島県いわき市泉町滝尻中瀬84-3</p>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <div className="w-6 h-6 flex items-center justify-center mr-4 mt-1">
                    <i className="ri-phone-line text-teal-600"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">電話番号</h4>
                    <p className="text-gray-600">080-9258-2284</p>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <div className="w-6 h-6 flex items-center justify-center mr-4 mt-1">
                    <i className="ri-time-line text-teal-600"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">営業時間</h4>
                    <p className="text-gray-600">9:30 - 20:00</p>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <div className="w-6 h-6 flex items-center justify-center mr-4 mt-1">
                    <i className="ri-calendar-line text-teal-600"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">定休日</h4>
                    <p className="text-gray-600">不定休</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-teal-600 text-white rounded-xl p-8">
              <h4 className="text-xl font-bold mb-4">初心者大歓迎！</h4>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                <div className="flex items-center">
                  <div className="w-5 h-5 flex items-center justify-center mr-3">
                    <i className="ri-check-line"></i>
                  </div>
                  <span>入会金0円</span>
                </div>
                <div className="flex items-center">
                  <div className="w-5 h-5 flex items-center justify-center mr-3">
                    <i className="ri-check-line"></i>
                  </div>
                  <span>お子様からご高齢の方まで対応</span>
                </div>
                <div className="flex items-center">
                  <div className="w-5 h-5 flex items-center justify-center mr-3">
                    <i className="ri-check-line"></i>
                  </div>
                  <span>一人ひとりに合わせたメニュー</span>
                </div>
                <div className="flex items-center">
                  <div className="w-5 h-5 flex items-center justify-center mr-3">
                    <i className="ri-check-line"></i>
                  </div>
                  <span>プロのトレーナーが丁寧に指導</span>
                </div>
              </div>
            </div>

            <div className="rounded-xl overflow-hidden">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d506.9956987626849!2d140.8734409947645!3d36.95299254912008!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x602113d8fba0610f%3A0x23a41a13723fa955!2z44Oc44OF44Kj44Kx44Ki5bCC6ZaA5bqXSCZL!5e0!3m2!1sen!2sjp!4v1760878593892!5m2!1sen!2sjp"
                width="100%"
                height="400"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="ボディケア専門店H&K 地図"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
